import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
    providedIn: 'root',
})
export class SignupGuard {
    constructor(private authService: AuthService, private router: Router) {}

    // @ts-ignore
    async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean> {
        if (this.authService.isLoggedIn || Boolean(localStorage.getItem('isUserLogged'))) {
            await this.router.navigate(['/']);
            return false;
        } else {
            return true;
        }
    }
}
